import { render, staticRenderFns } from "./BalanceModal.vue?vue&type=template&id=9ec6d160&scoped=true&"
import script from "./BalanceModal.vue?vue&type=script&lang=ts&"
export * from "./BalanceModal.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceModal.vue?vue&type=style&index=0&id=9ec6d160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec6d160",
  null
  
)

export default component.exports